import React, {Component} from "react";

import Logo from "./img/logo.png";
import Background from "./img/sfondoroadmap.png";
import Whitepaper from "./img/Whitepaper.pdf";

import { Container, Box, Center, Stack, Text} from "@chakra-ui/react";

import Navbar from "./components/navbar";
import Carousel from "./components/bootstrapcarousel";




export default class Roadmap extends Component {
    render() {
      return (
        <>
            <div className='container-fluid' style={{backgroundImage: "url(" + Background + ")", backgroundRepeat: "no-repeat", backgroundSize: "2120px", height: "1180px", weight: "1920px "}}>                
                <Navbar 
                img={Logo}
                color="#ffffff"/>
                <Center p={9}>
                  <Stack direction={['column', 'row']} spacing='250px' h='350px'>
                    <Container w='100%' h='600px' bg='trasparent' centerContent>
                      <Box  bg='trasparent'  w='100%'>
                        <Carousel/>
                      </Box>
                    </Container>
                    <Container w='100%' h='500px' bg='trasparent' centerContent>
                      <Box  bg='trasparent'  w='350px'  >                          
                        <a href={Whitepaper} className="button" download><i className="fa fa-download"></i><Text color='white' style={{fontFamily:"Roboto", fontSize:"45px"}}> DOWNLOAD WHITEPAPER </Text></a>
                      </Box>
                    </Container>
                  </Stack>
                </Center>                  
            </div>                         
        </>
      );
    }
  }